import { render, staticRenderFns } from "./UiAsyncSelect.vue?vue&type=template&id=4c48a7e7&"
import script from "./UiAsyncSelect.vue?vue&type=script&lang=js&"
export * from "./UiAsyncSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/modules/shared/ui/public/forms/fields/UiAsyncSelect.vue
// module id = 1122
// module chunks = 0